<!--  -->
<template>
    <div class="uploader">
        <GButton icon="upload" @click="onClickUpload">
            <slot></slot>
        </GButton>
        <slot name="tips"></slot>

        <div class="imgItem" v-for="(item,index) in fileList" :key="index">
            <div>
                <Icon class="loading" icon="loading" v-if="item.loading" />
                <img v-else width="50" :src="item.url" alt />
                <span :class="{error:status=== 'error'}">{{item.name}}</span>
            </div>
            <span @click="removeFile(index)">
                <Icon class="delete" icon="delete" />
            </span>
        </div>
        <div ref="input" style="width:0;height:0;overflow:hidden;"></div>
    </div>
</template>

<script>
import Icon from './icon'
import GButton from './button/button'
export default {
    name: 'uploader',
    components: {
        Icon,
        GButton
    },
    data() {
        return {
            src: '',
            status: 'success'
        }
    },
    props: {
        name: {
            type: String,
            required: true
        },
        action: {
            type: String,
            required: true
        },
        method: {
            type: String,
            default: 'POST'
        },
        parseResponse: {
            type: Function,
            required: true
        },
        beforeUpload: {
            type: Function
        },
        fileList: {
            type: Array,
            default: () => []
        }
    },
    methods: {
        removeFile(index) {
            let list = [...this.fileList]
            list.splice(index, 1)
            this.$emit('update:fileList', list)
        },
        onClickUpload() {
            const input = this.createInput()
            input.addEventListener('change', e => {
                this.updateFile(input.files)
                // this.updateFiles(input.files)
                input.remove()
            })
            input.click()
        },
        createInput() {
            this.$refs.input.innerHTML = ''
            const input = document.createElement('input')
            input.type = 'file'
            input.multiple = 'multiple'
            this.$refs.input.appendChild(input)
            return input
        },
        updateFiles(files) {
            let formData = new FormData()
            for (let i = 0; i < files.length; i++) {
                formData.append(this.name, files[i])
            }
            var xhr = new XMLHttpRequest()
            xhr.open(this.method, this.action)
            xhr.send(formData)
        },
        updateFile(files) {
            let arr = [...this.fileList]
            for (let i = 0; i < files.length; i++) {
                let file = files[i]
                if (this.beforeUpload) {
                    let flag = this.beforeUpload(file)
                    if (!flag) {
                        return
                    }
                }
                file.loading = true
                arr.push(file)
            }
            this.$emit('update:fileList', arr)
            for (let i = 0; i < files.length; i++) {
                 new Promise((resolve) => {
                    let file = files[i]
                    const { name, size, type } = file
                    const index = arr.indexOf(file)

                    let formData = new FormData()
                    formData.append(this.name, file)
                    var xhr = new XMLHttpRequest()
                    xhr.open(this.method, this.action, true)
                    xhr.onload = () => {
                        let url
                        url = xhr.response
                            ? this.parseResponse(xhr.response)
                            : ''
                        //关闭loading
                        let newArr = [...this.fileList]
                        newArr[index] = { name, size, type, url }
                        this.$emit('update:fileList', newArr)
                        this.$emit('success', xhr.response)
                        resolve(xhr.response)
                    }
                    xhr.onerror = () => {
                        let newArr = [...this.fileList]
                        newArr[index] = { name, size, type, status: 'error' }
                        this.$emit('update:fileList', newArr)
                        this.error(xhr)
                    }
                    xhr.setRequestHeader('If-Modified-Since', '0')
                    xhr.send(formData)
                })
            }
        },
        error(xhr) {
            this.status = 'error'
            this.$emit('error', xhr)
        }
    }
}
</script>
<style scoped lang='scss'>
@import './var';
.uploader {
    .loading {
        @include spin;
        width: 32px;
        height: 32px;
    }
    .delete {
        cursor: pointer;
        margin-left: 50px;
    }
    .error {
        color: red;
    }
    .imgItem {
        border: 1px solid #c0ccda;
        display: flex;
        align-items: center;
        padding: 10px;
        border-radius: 5px;
        margin-top: 10px;
        justify-content: space-between;
        > div {
            display: flex;
            justify-content: center;
            align-items: center;
        }
        img {
            width: 70px;
            height: 70px;
            margin-right: 10px;
            border: 1px solid #c0ccda;
        }
    }
}
</style>